import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
} from '@mui/material';
import { colors } from '../theme';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { SvgIcon } from '@mui/material';

// WhatsApp Icon
const WhatsAppIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M19.07 4.93C17.12 2.98 14.56 2 11.99 2C6.47 2 2.07 6.4 2.07 11.92c0 2.1.55 4.15 1.6 5.97L2 22l6.29-1.65c1.76.95 3.74 1.45 5.7 1.45h.01c5.52 0 9.92-4.4 9.92-9.92 0-2.65-1.03-5.14-2.9-7.02zM11.99 20.15c-1.78 0-3.53-.47-5.07-1.36l-.36-.21-3.75.98.99-3.65-.24-.38C3.62 13.35 3.13 12.68 3.13 11.92c0-4.68 3.8-8.48 8.48-8.48 2.26 0 4.38.88 5.98 2.48 1.6 1.6 2.48 3.72 2.48 5.98 0 4.7-3.8 8.52-8.48 8.52zm4.6-6.35c-.25-.13-1.48-.73-1.71-.81-.23-.08-.4-.13-.56.13-.16.25-.62.81-.76.97-.13.16-.27.19-.52.04-.25-.13-1.06-.39-2.01-1.24-.74-.66-1.24-1.48-1.39-1.73-.13-.23-.01-.36.1-.48.11-.11.25-.28.37-.42.12-.14.16-.25.25-.42.08-.16.04-.31-.02-.43-.06-.13-.56-1.35-.77-1.85-.2-.49-.41-.42-.56-.43-.14-.01-.3-.01-.46-.01-.16 0-.42.06-.63.31-.21.25-.8.78-.8 1.9 0 1.12.82 2.2.93 2.36.12.16 1.66 2.54 4.03 3.56.56.24.99.38 1.33.49.57.18 1.08.16 1.49.1.45-.07 1.41-.58 1.6-1.14.19-.56.19-1.04.13-1.14-.06-.1-.23-.16-.48-.28z"
    />
  </SvgIcon>
);

function Footer() {
  const currentYear = new Date().getFullYear();

  const handleNavClick = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: colors.black,
        color: colors.white,
        pt: 8,
        pb: 4,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
              }}
            >
              <Box
                component="img"
                src="/logo-white.png"
                alt="SolaCharge"
                sx={{ height: 50, mr: 2 }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <Typography
                sx={{
                  display: 'none',
                  color: colors.yellow,
                  fontWeight: 700,
                  fontSize: '1.8rem',
                }}
              >
                SolaCharge
              </Typography>
            </Box>

            <Typography
              sx={{
                color: colors.white,
                opacity: 0.8,
                mb: 3,
                lineHeight: 1.7,
              }}
            >
              Leading provider of integrated EV charging, solar, and energy
              storage solutions in Singapore.
            </Typography>

            <Box
              sx={{
                display: 'inline-flex',
                px: 2,
                py: 1,
                borderRadius: 2,
                bgcolor: `${colors.yellow}20`,
                border: `2px solid ${colors.yellow}`,
                mb: 3,
              }}
            >
              <Typography
                sx={{
                  color: colors.yellow,
                  fontWeight: 700,
                  fontSize: '0.9rem',
                }}
              >
                Licensed LTA EVCO Operator
              </Typography>
            </Box>

            {/* Social Media */}
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton
                component="a"
                href="https://www.facebook.com/profile.php?id=61585508062854"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: colors.white,
                  bgcolor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    bgcolor: colors.yellow,
                    color: colors.black,
                  },
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.linkedin.com/company/solacharge"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: colors.white,
                  bgcolor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    bgcolor: colors.yellow,
                    color: colors.black,
                  },
                }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.instagram.com/solacharge.official"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: colors.white,
                  bgcolor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    bgcolor: colors.yellow,
                    color: colors.black,
                  },
                }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://wa.me/6581887716"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: colors.white,
                  bgcolor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    bgcolor: '#25D366',
                    color: colors.white,
                  },
                }}
              >
                <WhatsAppIcon />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography
              variant="h6"
              sx={{
                color: colors.yellow,
                fontWeight: 700,
                mb: 2,
              }}
            >
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {[
                { label: 'Home', href: '#home' },
                { label: 'Solutions', href: '#solutions' },
                { label: 'Technology', href: '#technology' },
                { label: 'Products', href: '#products' },
                { label: 'Sustainability', href: '#sustainability' },
                { label: 'Projects', href: '#projects' },
              ].map((link) => (
                <Link
                  key={link.label}
                  onClick={() => handleNavClick(link.href)}
                  sx={{
                    color: colors.white,
                    opacity: 0.8,
                    textDecoration: 'none',
                    cursor: 'pointer',
                    '&:hover': {
                      color: colors.yellow,
                      opacity: 1,
                    },
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Services */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                color: colors.yellow,
                fontWeight: 700,
                mb: 2,
              }}
            >
              Our Services
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {[
                'AC Charging Solutions',
                'DC Fast Charging',
                'Energy Storage Systems',
                'Solar Integration',
                'CSMS Platform',
                'Maintenance & Support',
              ].map((service) => (
                <Typography
                  key={service}
                  sx={{
                    color: colors.white,
                    opacity: 0.8,
                    fontSize: '0.9rem',
                  }}
                >
                  {service}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{
                color: colors.yellow,
                fontWeight: 700,
                mb: 2,
              }}
            >
              Contact Us
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <LocationOnIcon
                  sx={{ color: colors.green, fontSize: 20, mt: 0.5 }}
                />
                <Typography
                  sx={{
                    color: colors.white,
                    opacity: 0.8,
                    fontSize: '0.9rem',
                  }}
                >
                  Kaki Bukit Road 1
                  <br />
                  Singapore 415934
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon sx={{ color: colors.green, fontSize: 20 }} />
                <Typography
                  sx={{
                    color: colors.white,
                    opacity: 0.8,
                    fontSize: '0.9rem',
                  }}
                >
                  info@solacharge.net
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon sx={{ color: colors.green, fontSize: 20 }} />
                <Typography
                  sx={{
                    color: colors.white,
                    opacity: 0.8,
                    fontSize: '0.9rem',
                  }}
                >
                  +65 8188 7716
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider sx={{ my: 4, bgcolor: 'rgba(255,255,255,0.1)' }} />

        {/* Bottom Bar */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography
            sx={{
              color: colors.white,
              opacity: 0.7,
              fontSize: '0.9rem',
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            © {currentYear} SolaCharge. All rights reserved. | Licensed LTA
            EVCO Operator
          </Typography>

          {/* <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2,
              justifyContent: { xs: 'center', md: 'flex-end' },
            }}
          >
            <Link
              href="#"
              sx={{
                color: colors.white,
                opacity: 0.7,
                textDecoration: 'none',
                fontSize: '0.9rem',
                '&:hover': {
                  color: colors.yellow,
                  opacity: 1,
                },
              }}
            >
              Privacy Policy
            </Link>
            <Typography sx={{ color: colors.white, opacity: 0.5 }}>|</Typography>
            <Link
              href="#"
              sx={{
                color: colors.white,
                opacity: 0.7,
                textDecoration: 'none',
                fontSize: '0.9rem',
                '&:hover': {
                  color: colors.yellow,
                  opacity: 1,
                },
              }}
            >
              Terms of Service
            </Link>
            <Typography sx={{ color: colors.white, opacity: 0.5 }}>|</Typography>
            <Link
              href="#"
              sx={{
                color: colors.white,
                opacity: 0.7,
                textDecoration: 'none',
                fontSize: '0.9rem',
                '&:hover': {
                  color: colors.yellow,
                  opacity: 1,
                },
              }}
            >
              Cookie Policy
            </Link>
          </Box> */}
        </Box>

      </Container>
    </Box>
  );
}

export default Footer;
